/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["ku",[["bn","pn"],["BN","PN"]],[["BN","PN"]],[["Y","D","S","Ç","P","Î","Ş"],["yşm","dşm","sşm","çşm","pşm","înî","şem"],["yekşem","duşem","sêşem","çarşem","pêncşem","înî","şemî"],["yş","dş","sş","çş","pş","în","şm"]],u,[["R","S","A","N","G","H","T","T","Î","C","M","B"],["rbn","sbt","adr","nsn","gln","hzr","trm","tbx","îln","cot","mjd","brf"],["rêbendan","sibat","adar","nîsan","gulan","hezîran","tîrmeh","tebax","îlon","cotmeh","mijdar","berfanbar"]],u,[["BZ","PZ"],u,["berî zayînê","piştî zayînê"]],1,[6,0],["dd.MM.y","d'ê' MMM'a' y'an'","d'ê' MMMM'a' y'an'","EEEE, d'ê' MMMM'a' y'an'"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",",".",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","%#,##0","#,##0.00 ¤","#E0"],"TRY","₺","lîreyê tirkî",{"JPY":["JP¥","¥"],"TRY":["₺"]},"ltr", plural];
